<Page {contentAreaLayout}>
    <PageHeader
        {headingLevel}
        title={pageTitle}
        {backLinkText}
        {backLinkUrl}
        {backLinkTarget}
        {backButtonText}
        {buttonDropdownId}
        {menuItems}
        {i18n}
        fixedHeaderSize={true}
        on:selectedOption
    >
        <svelte:fragment slot="header-menu">
            <slot name="header-menu" />
        </svelte:fragment>

        <svelte:fragment slot="subHeader">
            <slot name="subHeader" />
        </svelte:fragment>
    </PageHeader>

    {#if secondaryBlock}
        <div class="content-block content-block--secondary">
            <slot name="description-block"/>
        </div>
    {/if}

    <div class="content-block" bind:this={tableTemplateElement}>
        <slot name="filter-area" />

        {#if tableItems.length && !loading}
            <slot 
                tableCaption={tableCaption} 
                hideCaption={hideCaption}
                enablePanel={enablePanel}
                selections={selections}
                panelActions={panelActions}
                panelTerms={panelTerms}
                panelDescription={panelDescription}
                tableItems={tableItems}
            />

            {#if enablePagination && totalTableRows > 0 && currentPage && Object.keys(paginationTerms).length}
                <Pagination
                    ariaLiveUpdateType="polite"
                    i18n={paginationTerms}
                    showNumberOfItems
                    showPageSize
                    singlePageApp
                    {pageSizesList}
                    totalCount={totalTableRows}
                    bind:pageSize
                    bind:currentPage
                    on:pageClick={clearSelection}
                    on:previousPage={clearSelection}
                    on:nextPage={clearSelection}
                    on:pageClick
                    on:previousPage
                    on:nextPage
                    on:pageSizeChange
                />
            {/if}
        {:else if loading}
            <LoadingSpinner label={loadingLabel} size="large" iconClass="loading-spinner-color" visible />
        {:else}
            <EmptyState
                iconName={emptyStateIconName}
                headingLevel="h2"
                title={emptyStateTitle}
                description={emptyStateDescription}
                showLink={!!emptyStateHref}
                linkType={emptyStateLinkType}
                linkText={emptyStateLinkText}
                href={emptyStateHref}
            />
        {/if}
    </div>
</Page>

<script>
    import Page from "../../Page/v1/Page.svelte";
    import LoadingSpinner from "../../../nodes/LoadingSpinner/v1/LoadingSpinner.svelte";
    import PageHeader from "../../../patterns/PageHeader/v1/PageHeader.svelte";
    import Pagination from "../../../Navigation/Pagination/v1/Pagination.svelte";
    import EmptyState from "../../../nodes/EmptyState/v1/EmptyState.svelte";

    /** @type {string} */
    export let tableCaption;

    /** @type {string} */
    export let pageTitle;
    
    /** @type {string} */
    export let emptyStateTitle;

    /** @type {'full'|'wide'|'narrow'} */
    export let contentAreaLayout = 'wide';

    /** @type {'h1'|'h2'} */
    export let headingLevel = 'h1';
    
    /** @type {boolean} */
    export let hideCaption = false;

    /** @type {boolean} */
    export let enablePanel = false;
    
    /** @type {number} */
    export let totalTableRows = 0;

    /** @type {Array} */
    export let selections = [];

    /** @type {Array} */
    export let panelActions = [];

    /** @type {object} */
    export let panelTerms = {};

    /** @type {string} */
    export let panelDescription = '';
    
    /** @type {number} */
    export let currentPage = 1;

    /** @type {object} */
    export let paginationTerms = {};
    
    /** @type {number} */
    export let pageSize = 5;

    /** @type {array} */
    export let tableItems = [];
    
    /** @type {string} */
    export let backLinkText = undefined;
    
    /** @type {string} */
    export let backLinkUrl = undefined;
    
    /** @type {string} */
    export let backLinkTarget = '_self';
    
    /** @type {string} */
    export let backButtonText = undefined;
    
    /** @type {object[]} */
    export let menuItems = undefined;

    /** @type {object} */
    export let i18n = {};

    /** @type {string} */
    export let buttonDropdownId = "rnd" + Math.random().toString(36).replace('.', '');

    /** @type {array} */
    export let pageSizesList = [10, 25, 50, 100];

    /** @type {boolean} */
    export let secondaryBlock = false;

    /** @type {boolean} */
    export let enablePagination = true;

    /** @type {string} */
    export let emptyStateIconName = 'portfolio';

    /** @type {string} */
    export let emptyStateDescription = '';

    /** @type {string} */
    export let emptyStateHref = '';

    /** @type {string} */
    export let emptyStateLinkText = '';

    /** @type {'standalone'|'primary-standalone'} */
    export let emptyStateLinkType = 'standalone';

    /** @type {boolean} */
    export let loading = false;

    /** @type {string} */
    export let loadingLabel = 'loading';

    export function clearSelection() {
        if (!tableTemplateElement) return;

        tableTemplateElement.querySelectorAll('input[type="checkbox"]').forEach(box => {
            box.checked = false;
        });
        selections = [];
    }

    let tableTemplateElement;
</script>
